import React, { Component } from 'react';
import Footer from '../components/Principal/Footer';
import Header from '../components/Principal/Header';
import MensajeF from '../components/Mensaje_Flotante/MensajeF';
import Seccion1 from '../components/Eventos_Concursos/Seccion1';
import Seccion2 from '../components/Eventos_Concursos/Seccion2';

class EventosConcursos extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    render() {
        return (
            <React.Fragment>
                <Header id={2} />
                <MensajeF />
                <Seccion1 />
                <Seccion2 />
                <Footer />
            </React.Fragment>
        );
    }
}

export default EventosConcursos